var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "seeker-block" },
    [
      _vm._l(_vm.count, function (item, index) {
        return _c(
          "div",
          { key: item, staticClass: "seeker-block__wrapper" },
          [
            _c(_vm.component, {
              ref: "component",
              refInFor: true,
              tag: "component",
              staticClass: "seeker-block__content",
              attrs: { index: index },
              on: { change: _vm.onBlockDataChange },
            }),
            _vm._v(" "),
            index !== 0
              ? _c("div", { staticClass: "seeker-block__remove" }, [
                  _c(
                    "button",
                    {
                      staticClass: "seeker-block__remove-btn",
                      on: {
                        click: function ($event) {
                          return _vm.removeBlock(item, index)
                        },
                      },
                    },
                    [
                      _c("z-icon", {
                        attrs: { name: "close", width: "24", height: "24" },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "seekers-form__add-button" },
        [
          _c(
            "z-button",
            {
              attrs: { kind: "text" },
              on: {
                click: function ($event) {
                  return _vm.addBlock("experience")
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "right",
                  fn: function () {
                    return [
                      _c("z-icon", {
                        attrs: { name: "plus", width: "24", height: "24" },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [_c("span", { domProps: { innerHTML: _vm._s(_vm.btnText) } })]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }